import SettingsNotificationList from './SettingsNotificationList'
export default SettingsNotificationList
